var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartHandsIcon = function SvgHeartHandsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m18.507 20.5-9.336-8.752c-5.074-5.25 2.385-15.332 9.336-7.176 6.951-8.156 14.376 1.96 9.336 7.176zM5.5 36.5l-2.667-3.813c-.857-1.274-1.327-2.862-1.333-4.501v-8.283c0-.637.21-1.248.586-1.7.375-.45.884-.703 1.414-.703s1.04.253 1.414.704c.375.45.586 1.062.586 1.699v6.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.5 36.5v-4.914a7.6 7.6 0 0 0-1.178-4.095l-1.767-2.866c-.625-1.137-2.082-1.476-3.1-.721-.896.636-1.213 1.913-.73 2.932L7.82 30.52M31.5 36.5l3.333-3.813a7.04 7.04 0 0 0 1.667-4.501v-8.283c0-.637-.263-1.248-.732-1.7A2.55 2.55 0 0 0 34 17.5c-.663 0-1.299.253-1.768.704a2.36 2.36 0 0 0-.732 1.699v6.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24.5 36.5v-4.914a7.6 7.6 0 0 1 1.178-4.095l1.767-2.866c.625-1.137 2.082-1.476 3.1-.721.896.636 1.213 1.913.73 2.932l-2.093 3.685"
  })));
};
export default SvgHeartHandsIcon;